<template>
  <div class="presented">
    <!-- <van-nav-bar :title="title" left-text="" fixed @click-right="onClickRight">
      <van-icon
        slot="left"
        class="iconfont icon-zuojiantou"
        style="font-size: .25rem"
        @click="goBack"
      ></van-icon>
    </van-nav-bar> -->
    <GlobTopNav :title="title" :rightHidden="false"></GlobTopNav>

    <div class="presented-bg"></div>

    <div class="van-content">
      <div v-if="step == 1">
        <div>
          <van-field
            type="text"
            value=""
            label="对方账号"
            v-model="otherNum"
            placeholder="请输入对方账号"
          ></van-field>
          <van-field
            type="text"
            value=""
            label="转出额度"
            v-model="giveNum"
            placeholder="请输入要转赠的数量"
          ></van-field>
        </div>
        <p class="tips">您当前能转出的{{ unit }}值 {{ this.$store.state.userCount.point }}</p>
        <van-button class="next" @click="next()">下一步</van-button>
      </div>
      <div v-if="step == 2">
        <div>
          <van-field type="password" value="" v-model="password" placeholder="请输入您的登录密码">
            <img slot="left-icon" src="./../../../assets/img/pwd.svg" alt="" />
          </van-field>
          <div class="codebox div van-hairline van-field" style="padding-right: 0rem">
            <div class="van-field__left-icon">
              <img slot="left-icon" src="./../../../assets/img/code.svg" alt="" />
            </div>
            <div class="div__value">
              <input
                type="text"
                placeholder="请输入验证码"
                v-model="code"
                class="van-field__control"
              />
            </div>
            <div class="van-field__button">
              <div class="code" @click="refreshCode">
                <s-identify :identifyCode="identifyCode"></s-identify>
              </div>
            </div>
          </div>
        </div>
        <van-button class="next" @click="sendData()">立即转赠</van-button>
      </div>

      <div v-if="step == 3" class="pointsucceed">
        <div class="title">
          <img src="./../../../assets/img/success.svg" alt="" />
          <h3>转赠成功</h3>
        </div>
        <div class="userifno">
          <span class="div-text">对方账号：{{ this.otherNum }}</span>
          <span class="div-text">转出{{ unit }}：{{ this.giveNum }}{{ unit }}</span>
          <span class="div-text">转出时间：{{ time(times) }}</span>
        </div>
        <div class="ponit-btns">
          <van-button class="btn" @click="goHome()"> 返回首页 </van-button>
          <van-button class="btn view-btn" @click="godetail()"> 查看{{ unit }}记录 </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../../vuex/store";
import SIdentify from "../../../components/identify";
export default {
  name: "password",
  components: {
    SIdentify
  },
  computed: {
    unit: function() {
      return this.$store.state.unitinfo.name;
    }
  },
  store,
  data() {
    return {
      otherNum: "",
      giveNum: "",
      password: "",
      code: "",
      step: 1,
      title: "",
      identifyCodes: "1234567890", //图片验证码
      identifyCode: "", //图片验证码
      times: "",
      btn: false
    };
  },
  watch: {
    giveNum(val) {
      this.giveNum = this.giveNum.replace(/[^\d]+|(^0)+/g, "");
    }
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    onClickRight() {
      console.log("按钮");
    },
    godetail: function() {
      this.$router.push({ path: "/user/mymoney" });
    },
    goHome: function() {
      this.$router.push({ path: "/" });
    },
    time: function(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s;
      if (date.getSeconds() < 10) {
        s = "0" + date.getSeconds();
      } else {
        s = date.getSeconds();
      }
      return Y + M + D + h + m + s;
    },
    next: function() {
      if (this.otherNum == "") {
        this.$dialog
          .alert({
            title: "提示",
            message: "转赠账号不能为空！"
          })
          .then(() => {
            // on close
          });
      } else if (this.giveNum == "") {
        this.$dialog
          .alert({
            title: "提示",
            message: "转赠值不能为空！"
          })
          .then(() => {
            // on close
          });
      } else {
        this.step = 2;
        this.title = "账户验证";
      }
    },
    sendData: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      if (this.btn == false) {
        this.btn = true;
        if (this.code != this.identifyCode) {
          this.$toast("验证码错误！");
          this.refreshCode();
          this.btn = false;
        } else {
          this.$dialog
            .confirm({
              title: "提示 ",
              message:
                "您将转赠" +
                this.giveNum +
                this.unit +
                "给用户<br/>" +
                this.otherNum +
                ""
            })
            .then(() => {
              this.$api.post(
                "user/point/transfer",
                {
                  id_example: mallid,
                  token_user: isUser,
                  account: this.otherNum,
                  point: this.giveNum,
                  pwd_user: this.password
                },
                res => {
                  if (res.data.code == "100") {
                    this.$store.commit("userInfo");
                    //              this.$router.push({ name: 'Pointsucceed' })
                    //              this.$router.push({ name: 'User' })
                    this.times = res.data.data.time;
                    this.step = 3;
                    this.title = "转赠成功";
                    this.btn = false;
                  } else {
                    if (res.data.message == "token验证失败") {
                      this.$dialog
                        .confirm({
                          title: "提示 ",
                          message: "您还未登录是否去登录？"
                        })
                        .then(() => {
                          this.$router.push({ name: "NoteLogin" });
                        })
                        .catch(() => {});
                      this.btn = false;
                    } else {
                      this.$toast(res.data.message);
                      this.refreshCode();
                      this.btn = false;
                    }
                  }
                }
              );
            })
            .catch(() => {
              this.btn = false;
            });
        }
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    }
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    var unit = localStorage.getItem("unit");
    var unitname = unit + "转赠";
    this.title = unitname;
  }
};
</script>

<style lang="less">
.presented {
  position: relative;
  min-height: 100vh;
  width: 100%;
  background-color: #f5f5f5;
  .presented-bg {
    width: 100%;
    height: 3.3rem;
    background: linear-gradient(133deg, #ffffff 0%, #f3e1d0 100%);
    position: absolute;
    top: 0;
  }
  .van-content {
    width: calc(100% - 0.6rem);
    height: auto;
    background: #ffffff;
    border-radius: 0.24rem;
    margin: 1.4rem auto 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 2;
    box-sizing: border-box;
    padding: 0 0.2rem;
    padding-bottom: 0.6rem;

    .van-field__control {
      &::placeholder {
        color: rgba(38, 38, 38, 0.5) !important;
      }
    }

    .van-cell,
    .div {
      padding: 0.54rem 0.3rem !important;
      border-bottom: 0.02rem solid #f5f5f5;
      display: flex;
      align-items: center;

      &::after {
        border: none;
      }

      .van-cell__title {
        width: 4em;
      }

      .van-field__body,
      .div__value {
        padding-left: 0.24rem;
        font-size: 0.28rem;
      }
      .div__title {
        padding-left: 0.3rem;
        font-size: 0.28rem;
        font-weight: bold;
        color: rgba(38, 38, 38, 0.8);
        line-height: 0.48rem;
      }

      .van-field__left-icon {
        display: flex;
        align-items: center;

        img {
          width: 0.44rem;
          height: 0.48rem;
        }
      }

      .div__value {
        padding-left: 0.24rem;
      }
    }

    .tips {
      font-size: 0.24rem;
      font-weight: 400;
      color: #929292;
      line-height: 0.42rem;
      padding-left: 0.3rem;
      margin-top: 0.22rem;
    }

    .next {
      width: calc(100% - 0.4rem);
      height: 0.96rem;
      margin-left: 0.2rem;
      background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
      border-radius: 0.48rem;
      font-size: 0.3rem;
      font-weight: 500;
      color: #ffffff;
      line-height: 0.42rem;
      margin-top: 0.42rem;
    }

    .code {
      /*margin: 4rem auto;*/
      width: auto;
      height: 0.6rem;
      .s-canvas {
        width: 100%;
        height: 100%;
      }
      #s-canvas {
        width: 100%;
        height: 100%;
      }
    }

    .pointsucceed {
      margin-top: 0.4rem;
      padding: 0 0.1rem;
      .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img {
          width: 0.88rem;
          height: 0.88rem;
        }
        h3 {
          font-size: 0.36rem;
          font-weight: 500;
          color: #262626;
          line-height: 0.5rem;
          margin-top: 0.12rem;
        }
      }

      .userifno {
        display: flex;
        flex-direction: column;
        margin-top: 0.4rem;

        span {
          font-size: 0.28rem;
          font-weight: 400;
          color: rgba(38, 38, 38, 0.5);
          line-height: 0.48rem;
          margin-top: 0.18rem;
        }
      }

      .ponit-btns {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 0.68rem;

        .btn {
          width: 2.9rem;
          height: 0.96rem;
          background: #fdf5f5;
          border-radius: 0.5rem;
          border: 0.02rem solid #e23331;
          font-size: 0.3rem;
          font-weight: 500;
          color: #e23331;
          line-height: 0.42rem;
        }

        .view-btn {
          width: 3.2rem;
          background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
          color: #fff;
        }
      }
    }
  }

  .codebox {
    line-height: 0.35rem;
  }
  .codebox .van-button {
    height: 0.3rem;
    line-height: 0.3rem;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/presented/index.vue